export default __webpack_public_path__ + "static/media/pentagon.039de96e.png";